module.exports = __webpack_public_path__ + "img/639.13a19a72.jpg";